import React, { useEffect, useState } from 'react';
import { Backdrop, Box, Modal, ClickAwayListener } from '@mui/material';
import { Fade } from '@mui/material';
import PbiFilterTimeline from '../PbiFilter/PbiFilterTimeframeContainer';
import MobileDatePicker from './MobileDatePicker';
import { TimeFrame } from 'models/ReportData';
import { isHistorical } from 'helpers/date';
import { mobileFilterCalendarModalStyles } from './MobileFilterCalendarModal.styles';

type MobileFilterCalendarModalProps = {
  isOpen: boolean;
  pbiReportHeight: number;
  screenHeight: number;
  screenWidth: number;
  timeframe: TimeFrame;
  startDate: Date;
  endDate: Date;
  selectedDay: Date;
  filterState: any;
  filterData: any;
  setActiveDate: (date: Date) => void;
  closeCalendarModal: () => void;
  onClose: () => void;
  onDone: () => void;
};
const MobileFilterCalendarModal = (props: MobileFilterCalendarModalProps) => {
  const {
    isOpen,
    pbiReportHeight,
    screenHeight,
    screenWidth,
    timeframe,
    startDate,
    endDate,
    selectedDay,
    filterState,
    filterData,
    closeCalendarModal,
    setActiveDate,
    onClose,
    onDone,
  } = props;
  //*this is state for controlled component MobileFilterTimeFrame.tsx used as callback - need to be shared with date picker

  //*this value comes from css styles
  const verticalOffset = 77;
  const topBorder = screenHeight - pbiReportHeight + verticalOffset;
  const popUpStyle = {
    ...mobileFilterCalendarModalStyles.popUpBase,
    top: topBorder,
  };
  const popUpHeight = screenHeight - topBorder;

  const handleLastUpdateClick = () => {
    setActiveDate(filterData.endDate || new Date());
    closeCalendarModal();
  };
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      BackdropProps={{
        timeout: 500,
      }}
      BackdropComponent={Backdrop}
      data-testid="mobile-filter-calendar-modal">
      <Fade in={isOpen}>
        <Box id="transition-modal-title" style={popUpStyle} data-testid="mobile-modal-content">
          <ClickAwayListener onClickAway={closeCalendarModal}>
            <Box
              sx={mobileFilterCalendarModalStyles.mobileModalDatePicker(screenWidth, popUpHeight)}>
              <Box
                sx={mobileFilterCalendarModalStyles.pbiFilterTimelinePlaceHolder}
                data-testid="pbi-filter-timeline-container">
                <PbiFilterTimeline isMobile={true} />
              </Box>
              <Box
                sx={mobileFilterCalendarModalStyles.datePickerPlaceHolder}
                data-testid="date-picker-container">
                <MobileDatePicker
                  timeframe={timeframe}
                  startDate={startDate}
                  endDate={endDate}
                  selectedDay={selectedDay}
                  setActiveDate={setActiveDate}
                  closeCalendarModal={closeCalendarModal}
                />
              </Box>
              <Box
                sx={mobileFilterCalendarModalStyles.todayButtonPlaceHolder(popUpHeight, 66)}
                data-testid="today-button-container">
                <Box
                  component="button"
                  sx={mobileFilterCalendarModalStyles.todayButton}
                  data-testid="today-button"
                  disabled={
                    !isHistorical({
                      day: filterState.selectedDate,
                      lastUpdate: filterData.endDate,
                    })
                  }
                  onClick={handleLastUpdateClick}>
                  TODAY
                </Box>
              </Box>
            </Box>
          </ClickAwayListener>
        </Box>
      </Fade>
    </Modal>
  );
};
export default MobileFilterCalendarModal;
